<template>
    <transition name="table-container-transition" appear>
        <div class="table-card-container" v-if="!hideTable">
            <b-card class="table-card">
                <div class="d-flex flex-column pb-2 mb-n5">
                    <div class="d-flex justify-content-between">
                        <h4 class="font-weight-bold">
                            {{ title }}
                        </h4>
                        <b-button class="btn-xs" variant="primary" size="sm" @click="toggleExtraColumns">{{ showExpandedColumns ? "Hide details" : "Show details" }}</b-button>
                    </div>
                    <h6 class="text-left ml-1">{{ subtitle }}</h6>
                </div>
                <div>
                    <div class="table-header-divider"></div>
                    <b-table
                        thead-class="toplist-header"
                        :fields="visibleFields"
                        class="tablemainresultclass"
                        :items="levelOneProgramsWithLevelTwoPrograms"
                        bordered
                        small
                        primary-key="index"
                        striped
                        :sort-compare-options="{ numeric: true, sensitivity: 'base' }"
                        sort-compare-locale="sv"
                        :head-variant="'dark'"
                        sort-by="measure_1"
                        sort-desc
                    >
                        <template v-slot:cell(ranking)="row">
                            <div class="ranking">
                                <span>{{ row.item.index + 1 }}</span>
                            </div>
                        </template>
                        <template v-slot:cell(plussign)="row">
                            <div class="plusminuscontainer" v-if="row.item.numberOfLvl2Objects > 1">
                                <div @click="clickedPlusMinusSign(row)" class="plusminusbutton">
                                    <font-awesome-icon v-if="!row.item._showDetails" icon="fa fa-plus-circle" class="plusminusicon" />
                                    <font-awesome-icon v-else icon="fa fa-minus-circle fa-1x" class="plusminusicon" />
                                </div>
                            </div>
                            <div v-else-if="row.item.numberOfLvl2Objects === 1">
                                {{ setLevelOneProgramToLevelTwoProgram(row.item) }}
                            </div>
                        </template>
                        <template v-slot:head()="field">
                            <span class="measureheader" v-html="getTableFieldLabel(field)"></span>
                        </template>
                        <template v-slot:cell(providerName)="row">
                            <span v-if="row.item.providerNameVhtml != undefined" v-html="row.item.providerNameVhtml"></span>
                            <span v-else>{{ row.item.providerName }}</span>
                        </template>
                        <template #row-details="row">
                            <b-table-lite
                                class="mb-0 detail-row-table"
                                :class="groupClassOddEven(row.index)"
                                :tbody-tr-class="detailRowClassOddEven(row.index)"
                                thead-class="hideheader"
                                :fields="visibleFields"
                                :items="row.item.levelTwoPrograms"
                                :striped="false"
                                borderless
                            >
                                <template v-slot:cell(providerName)="detailRow">
                                    <span v-if="detailRow.item.providerNameVhtml != undefined" v-html="detailRow.item.providerNameVhtml"></span>
                                    <span v-else>{{ detailRow.item.providerName }}</span>
                                </template>
                            </b-table-lite>
                        </template>
                    </b-table>
                </div>
            </b-card>
        </div>
    </transition>
</template>

<script>
export default {
    name: "ToplistTable",
    props: {
        hideTable: {
            type: Boolean,
            default: false,
        },
        showExpandedColumns: {
            type: Boolean,
            default: false,
        },
        getter: {
            type: String,
        },
        title: {
            type: String,
            default: "",
        },
        subtitle: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            contractedStateColumns: ["ranking", "title", "providerName", "measure_1"],
            expandedStateColumns: ["ranking", "plussign", "date", "time", "title", "providerName", "episode", "seasonNumber", "titleCode", "measure_1"],
        }
    },
    watch: {
        showExpandedColumns: function() {
            if (!this.showExpandedColumns) {
                for (const row of this.levelOneProgramsWithLevelTwoPrograms) {
                    if (row?._showDetails) {
                        row._showDetails = false
                    }
                }
            }
        },
    },
    computed: {
        levelOneProgramsWithLevelTwoPrograms() {
            return this.$store.getters[this.getter].data.levelOneProgramsWithLevelTwoPrograms
        },
        allFields() {
            if (this.$store.getters[this.getter]?.data?.columns.length > 0) {
                let fields = [...this.$store.getters[this.getter].data.columns]
                fields.unshift({ key: "ranking", label: "", thClass: "ranking-th", tdClass: "ranking-td" }, { key: "plussign", tdClass: "plusminussigntd", thClass: "plusminussignth", label: "" })
                for (const field of fields) {
                    if (field.key === "date") {
                        field.thClass = "date-th"
                    } else if (field.key === "title") {
                        field.thClass = "title-th"
                    } else if (field.key == "providerName") {
                        field.thClass = "provider-th"
                    } else if (field.key == "titleCode") {
                        field.thClass = "title-code-th"
                    } else if (field.key == "time") {
                        field.thClass = "time-th"
                    } else if (field.key == "episode") {
                        field.thClass = "episode-th"
                    } else if (field.key == "seasonNumber") {
                        field.thClass = "season-th"
                    }
                }
                return fields
            }
            return null
        },
        visibleFields() {
            if (this.showExpandedColumns) {
                return this.expandedStateColumns.map(colKey => {
                    return this.allFields.find(f => f.key === colKey)
                })
            }
            return this.contractedStateColumns.map(colKey => {
                return this.allFields.find(f => f.key === colKey)
            })
        },
    },
    methods: {
        clickedPlusMinusSign(row) {
            this.$set(row.item, "_showDetails", !row.item._showDetails)
        },
        setLevelOneProgramToLevelTwoProgram(row) {
            for (const column of this.$store.getters[this.getter].data.columns) {
                row[column.key] = row.levelTwoPrograms[0][column.key]
            }
        },
        detailRowClassOddEven(index) {
            return index % 2 == 0 ? "row-even detail-row" : "row-odd detail-row"
        },
        groupClassOddEven(index) {
            return index % 2 == 0 ? "group-even" : "group-odd"
        },
        getTableFieldLabel(field) {
            if (!field.field.key.includes("measure")) {
                return field.field.label
            }

            if (field.field.subHeader.includes("(tv-data)")) {
                field.field.targetGroupHeader = field.field.subHeader.replace("(tv-data)", "")
                field.field.sourceHeader = "(tv-data)*"
            } else if (field.field.subHeader.includes("(online-data)")) {
                field.field.targetGroupHeader = field.field.subHeader.replace("(online-data)", "")
                field.field.sourceHeader = "(online-data)*"
            } else if (field.field.subHeader.includes("Total")) {
                field.field.targetGroupHeader = field.field.subHeader.replace("Total", "")
                field.field.sourceHeader = "Total"
            }

            return `${field.field.header} <span class="measureagewrapper">${field.field.targetGroupHeader}</span><span class="measureagewrapper">${field.field.sourceHeader}</span>`
        },
        toggleExtraColumns() {
            this.$emit("onExpandColumnClick")
        },
    },
}
</script>

<style>
.table tbody tr .plusminussigntd {
    vertical-align: inherit;
    font-size: 1rem !important;
}
.choose-checkbox-th {
    width: 3rem;
}
</style>
<style scoped>
.table-header-divider {
    padding-top: 3rem;
    border-bottom: 1px solid #dee2e6;
}
::v-deep .table-card-container {
    flex: 50% !important;
    margin: 1rem !important;
}
/* this is just copied from the actual size of table card at initial load */
.table-card {
    min-width: 718px !important;
    min-height: 513px !important;
    border-radius: 10px;
    border: none;
    border-top: 1px solid #e0e0e0;
    border-right: 1px solid #e0e0e0;
    box-shadow: -0.2px 1px 1.4px rgba(0, 0, 0, 0.09), -0.6px 3px 3.5px rgba(0, 0, 0, 0.067), -1.2px 6px 7.1px rgba(0, 0, 0, 0.061), -2.6px 12px 14.6px rgba(0, 0, 0, 0.054),
        -7px 24px 40px rgba(0, 0, 0, 0.04);
}
::v-deep .toplist-header {
    line-height: 2.5;
}
::v-deep .ranking-td {
    border-color: transparent !important;
    font-size: 1rem;
    font-weight: bold;
    text-align: center;
    color: black !important;
    min-width: 2rem !important;
}
::v-deep .ranking-th {
    min-width: 2rem !important;
    width: 2rem !important;
}
::v-deep .plusminussignth {
    min-width: 2.2rem !important;
    width: 2.2rem !important;
    position: relative;
}
::v-deep .date-th {
    min-width: 7rem;
    width: 7rem;
}
::v-deep .title-th {
    min-width: 17rem;
    width: 17rem;
}
::v-deep .provider-th {
    min-width: 13rem;
    width: 13rem;
}
::v-deep .title-code-th {
    min-width: 10rem;
    width: 10rem;
}
::v-deep .time-th {
    min-width: 5rem !important;
    width: 5rem !important;
}
::v-deep .episode-th {
    min-width: 5rem;
    width: 5rem;
}
::v-deep .season-th {
    min-width: 5rem;
    width: 5rem;
}
::v-deep .measurethclass {
    text-align: right !important;
    width: 8rem !important;
    min-width: 8rem !important;
}
.measureheader {
    text-align: inherit !important;
    display: flex !important;
    flex-direction: column !important;
}
::v-deep .measureagewrapper {
    text-align: right !important;
    justify-self: flex-end !important;
    align-self: flex-end !important;
    margin-left: 0 !important;
    padding-left: 0 !important;
}
::v-deep .table tr td {
    font-size: 1rem;
}
::v-deep .table th {
    font-size: 0.8rem;
    background-color: white;
    color: black;
    border-color: transparent !important;
    border-width: 2px 1px 2px 1px !important;
    border: none;
    vertical-align: bottom;
    padding-top: 0;
    padding-bottom: 0;
}
.resultgrey {
    background-color: #6c757d;
}
.table.detail-row-table {
    text-align: left;
    table-layout: auto !important;
    border: none !important;
}
::v-deep .table.detail-row-table tr td {
    font-size: 0.8rem !important;
}
.table.tablemainresultclass {
    text-align: left;
    table-layout: auto !important;
    border: none !important;
}
.plusminusicon {
    color: #337ab7;
    font-size: 1.25em;
    margin: auto;
    display: block;
}
::v-deep .detail-row {
    background-color: transparent !important;
}
/* table is using bootstrap striped attribute for main rows and index based css for detail rows*/
::v-deep .row-even {
    background-color: #ffffff;
}
::v-deep .row-odd {
    background-color: #f2f2f2;
}
::v-deep .group-even {
    background-color: #f2f2f2;
}
::v-deep .group-odd {
    background-color: #ffffff;
}
::v-deep tbody tr td {
    border: none !important;
}
::v-deep .plusminusbutton {
    display: flex;
    position: relative;
    z-index: 2;
    padding: 0.4em 0;
    margin: -0.4em 0;
    cursor: pointer;
}
::v-deep .b-table-has-details td:not(:last-child) {
    border-left: 1px solid rgba(255, 255, 255, 0);
    border-right: 1px solid rgba(255, 255, 255, 0);
}

::v-deep .b-table-has-details td:first-child {
    border-left: 1px solid #dee2e6;
    border-right: 0px solid #dee2e6;
}
::v-deep .b-table-has-details td:nth-child(2) {
    border-left: 0px solid #dee2e6;
    border-right: 0px solid #dee2e6;
}
/* constructing the hierarchy lines in the plussign column */
::v-deep .plusminussigntd {
    padding: 0;
    position: relative;
}
/* hiding the overflowing line behind transparent part of +/- icon */
::v-deep .plusminusbutton::before {
    content: "";
    background: white;
    z-index: -1;
    height: 37%;
    left: 12px;
    position: absolute;
    top: 32%;
    width: 10px;
}
::v-deep .b-table-has-details td:nth-child(2)::after {
    content: "";
    background: #a9b1b8;
    height: 42%;
    left: 16px;
    position: absolute;
    top: 60%;
    width: 0.5px;
    z-index: 1;
}
::v-deep .detail-row-table .plusminussigntd::before {
    content: "";
    background: #a9b1b8;
    width: 50%;
    left: 16px;
    position: absolute;
    top: 50%;
    height: 0.5px;
}
::v-deep .detail-row-table .plusminussigntd:nth-child(2)::after {
    content: "";
    background: #a9b1b8;
    height: 100%;
    left: 16px;
    position: absolute;
    top: -50%;
    width: 0.5px;
}
/* table transitions */
.table-container-transition-enter-to,
.table-container-transition-leave {
    transition: opacity 0.35s ease-in-out;
}
.table-container-transition-enter,
.table-container-transition-leave-to {
    opacity: 0;
}
</style>
